import type TrailDetails from '@alltrails/core/types/TrailDetails';
import getLocationName from '@alltrails/core/utils/getLocationName';
import type Trail from '@alltrails/types/Trail';

const getTrailLocationName = (trail: Trail | TrailDetails) => {
  if (trail.area) {
    return trail.area.name;
  }

  return getLocationName(trail.location);
};

export default getTrailLocationName;
